import React from 'react';
import SectionTitle from '../home-section-title';
import Reveal from '../../reveal';
import styles from './home-projects.module.css';
import { chunk } from '../../../utils/helper-functions';
import ProjectsCol from './home-projects-col';
import ButtonArrow from '../../button-arrow';

const HomeProjects = props => {
  const { projects } = props;
  const settings = {
    sectionTitle: `Our Work`,
  };

  const chunkProjects = chunk(projects, 2);

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <div className={styles.projects}>
          <div className={styles.col}>
            <Reveal>
              <SectionTitle
                sectionName={settings.sectionTitle}
                isInView={props.isInView}
              />
            </Reveal>
            <div className={styles.first}>
              <ProjectsCol projects={chunkProjects[0]} />
            </div>
          </div>
          <div className={styles.col}>
            <div className={styles.second}>
              <ProjectsCol projects={chunkProjects[1]} />
            </div>
          </div>
        </div>
        <div className={styles.viewAll}>
          <ButtonArrow message={'View All Work'} url={'our-work'} />
        </div>
      </div>
    </div>
  );
};

export default HomeProjects;



// WEBPACK FOOTER //
// ./src/components/home/home-projects/index.js